import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  // State
  const isDark = ref(false)
  const systemPreference = ref('light')

  // Getters
  const currentTheme = computed(() => isDark.value ? 'dark' : 'light')
  
  // Actions
  const initTheme = () => {
    // Check for saved theme preference or default to system preference
    const savedTheme = localStorage.getItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    
    systemPreference.value = prefersDark ? 'dark' : 'light'
    
    if (savedTheme) {
      isDark.value = savedTheme === 'dark'
    } else {
      isDark.value = prefersDark
    }
    
    applyTheme()
    
    // Listen for system theme changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      systemPreference.value = e.matches ? 'dark' : 'light'
      if (!localStorage.getItem('theme')) {
        isDark.value = e.matches
        applyTheme()
      }
    })
  }

  const toggleTheme = () => {
    isDark.value = !isDark.value
    localStorage.setItem('theme', currentTheme.value)
    applyTheme()
  }

  const setTheme = (theme) => {
    isDark.value = theme === 'dark'
    localStorage.setItem('theme', theme)
    applyTheme()
  }

  const applyTheme = () => {
    const htmlElement = document.documentElement
    
    if (isDark.value) {
      htmlElement.classList.add('dark')
    } else {
      htmlElement.classList.remove('dark')
    }
    
    // Update meta theme-color
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', isDark.value ? '#0f172a' : '#6366f1')
    }
  }

  return {
    // State
    isDark,
    systemPreference,
    
    // Getters
    currentTheme,
    
    // Actions
    initTheme,
    toggleTheme,
    setTheme
  }
})